module.exports = __webpack_public_path__ + "img/64.4f551e71.png";